import { MediaType } from '../MediaType';
// eslint-disable-next-line no-restricted-imports
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

import { updateContentWithRetry } from './sharedTemplateBlueprintReqFns';

export const experimentalUpdateDraftWithTemplate: ExperimentalMutations['experimentalUpdateDraftWithTemplate'] =
	async (
		_,
		{ contentId, spaceKey, blueprint, context, title, parentPageId },
		{ network: { cfetch } },
	) => {
		const blueprintSpec = JSON.parse(blueprint);
		if (!blueprintSpec) {
			throw new Error('blueprint spec not found');
		}
		const contextValue = (context && JSON.parse(context)) || {};

		const content: any = {
			id: contentId,
			type: 'page',
			title,
			status: 'draft',
			space: {
				key: spaceKey,
			},
			version: {
				number: 1,
			},
		};

		if (parentPageId && parentPageId !== 'no-parent-page') {
			content.ancestors = [{ id: parentPageId }];
		}

		const url = `/wiki/rest/api/content/${contentId}/instance`;
		const method = 'PUT';
		const headers = {
			'Content-Type': MediaType.JSON,
		};
		const pageData = {
			content,
			contentBlueprintSpec: {
				contentTemplateId: blueprintSpec.templateId,
				context: contextValue,
			},
		};

		return updateContentWithRetry(cfetch, url, method, headers, pageData);
	};
